import { useEffect, useState } from 'react';
import SignaturePad from '../../components/ui/SignaturePad';
import { request, storageUrl } from '../../services/api';

export default function SettingsPage({ token }) {
  const [form, setForm] = useState({});
  const [files, setFiles] = useState({});
  const [ownerSignatureDataUrl, setOwnerSignatureDataUrl] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    request('/api/contracts/settings', { token }).then((response) => setForm(response.data || {}));
  }, [token]);

  const submit = async (event) => {
    event.preventDefault();
    const data = new FormData();
    Object.entries(form).forEach(([key, value]) => data.append(key, value || ''));
    Object.entries(files).forEach(([key, file]) => file && data.append(key, file));
    if (ownerSignatureDataUrl) data.append('owner_signature_data_url', ownerSignatureDataUrl);
    await request('/api/contracts/settings', { token, method: 'POST', body: data, form: true });
    setMessage('Company settings saved.');
  };

  return (
    <section className="panel">
      <h2>Company settings</h2>
      <form onSubmit={submit} className="form-grid">
        {['company_name', 'company_email', 'company_phone', 'company_address', 'owner_name', 'owner_title', 'website'].map((field) => (
          <label key={field}>{field.replaceAll('_', ' ')}<input value={form[field] || ''} onChange={(e) => setForm({ ...form, [field]: e.target.value })} /></label>
        ))}
        <label>Company logo<input type="file" accept="image/*" onChange={(e) => setFiles({ ...files, company_logo: e.target.files[0] })} />{form.company_logo && <img className="thumb" src={storageUrl(form.company_logo)} alt="" />}</label>
        <label>Upload owner signature<input type="file" accept="image/*" onChange={(e) => setFiles({ ...files, owner_signature: e.target.files[0] })} />{form.owner_signature && <img className="thumb" src={storageUrl(form.owner_signature)} alt="" />}</label>
        <div className="full">
          <label>Draw owner signature</label>
          <SignaturePad onChange={setOwnerSignatureDataUrl} />
        </div>
        <button className="primary">Save settings</button>
      </form>
      {message && <div className="alert success">{message}</div>}
    </section>
  );
}
